import { CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgSelectModule } from '@ng-select/ng-select';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { QRCodeModule } from 'angularx-qrcode';
import { NgbDatepickerModule, NgbPopoverModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxPaginationModule } from 'ngx-pagination';
import { PhoneInputComponent } from 'src/app/components/phone-number-input/phone-input.component';
import { SharedModule } from '../shared/shared.module';
import { AgreementCheckboxComponent } from './agreement-checkbox/agreement-checkbox.component';
import { AuthRecommendationModalComponent } from './auth-recommendation-modal/auth-recommendation-modal.component';
import { SearchButtonGroupComponent } from './buttons/search-button-group.component';
import { SubmitButtonGroupComponent } from './buttons/submit-button-group.component';
import { CardComponent } from './card/card.component';
import { ChatModalComponent } from './chat-modal/chat-modal.component';
import { CheckboxListComponent } from './checkbox-list/checkbox-list.component';
import { ContentWrapperComponent } from './content-wrapper/content-wrapper.component';
import { DatepickerComponent } from './datepicker/datepicker.component';
import { AuthValidationComponent } from './form/form-helpers/validation/auth-validation/auth-validation.component';
import { ValidationComponent } from './form/form-helpers/validation/validation.component';
import { FormComponent } from './form/form.component';
import { InputContainerComponent } from './form/input-fields/input-container/input-container.component';
import { InputLabelComponent } from './form/input-fields/input-label/input-label.component';
import { InfoModalComponent } from './info-modal/info-modal.component';
import { PopoverContentComponent } from './info-popover/popover-content.component';
import { PopoverComponent } from './info-popover/popover.component';
import { InputGroupComponent } from './input-group/input-group.component';
import { LanguageSwitchComponent } from './language-switch/language-switch.component';
import { ListItemCardComponent } from './list-item-card/list-item-card.component';
import { ListItemComponent } from './list-item-card/list-item.component';
import { MenuModalComponent } from './menu-modal/menu-modal.component';
import { MultipleRadioButtonGroupComponent } from './multiple-radio-button-group/multiple-radio-button-group.component';
import { NavItemComponent, NavItemListComponent } from './nav-items';
import { NavigationListComponent } from './navigation-list/navigation-list.component';
import { ProfileMenuSwitchComponent } from './profile-menu-switch/profile-menu-switch.component';
import { RadioButtonComponent } from './radio-button/radio-button.component';
import { SearchFormComponent } from './search-form/search-form.component';
import { SelectComponent } from './select/select.component';
import { SkeletonLoaderComponent } from './skeleton-loader/skeleton-loader.component';
import { CustomStepperComponent } from './stepper';
import { SwitchButtonWithDescriptionComponent } from './switch-button-with-description/switch-button-with-description.component';
import { SwitchButtonComponent } from './switch-button/switch-button.component';
import { SelectedItemsComponent } from './table/selected-items/selected-items.component';
import { TableRowComponent } from './table/table-row/table-row.component';
import { TableComponent } from './table/table.component';
import { TextareaComponent } from './textarea/textarea.component';
import { FileIconComponent } from './upload/file-icon/file-icon.component';
import { UploadComponent } from './upload/upload.component';
import { UserMessageChatInputModalComponent } from './user-message-chat-input-modal/user-message-chat-input-modal.component';
import { MessageContainerComponent } from './user-message-thread/message-container/message-container.component';
import { MessageComponent } from './user-message-thread/message/message.component';
import { UserMessageThreadComponent } from './user-message-thread/user-message-thread.component';

const MODULES: any[] = [
  CommonModule,
  SharedModule,
  NgbPopoverModule,
  NgbDatepickerModule,
  AngularSvgIconModule.forRoot(),
  CdkStepperModule,
  NgxPaginationModule,
  NgSelectModule,
  QRCodeModule,
];

const SERVICES: any[] = [];

const MODULES_EXPORT: any[] = [
  CdkStepperModule,
  AngularSvgIconModule.forRoot(),
];

const COMPONENTS: any[] = [
  ContentWrapperComponent,
  NavItemComponent,
  NavItemListComponent,
  MenuModalComponent,
  SwitchButtonComponent,
  CardComponent,
  InfoModalComponent,
  PopoverComponent,
  PopoverContentComponent,
  CustomStepperComponent,
  TextareaComponent,
  RadioButtonComponent,
  DatepickerComponent,
  FileIconComponent,
  UploadComponent,
  ValidationComponent,
  InputLabelComponent,
  InputContainerComponent,
  FormComponent,
  InputGroupComponent,
  SelectComponent,
  TableComponent,
  SelectedItemsComponent,
  ListItemCardComponent,
  ListItemComponent,
  MultipleRadioButtonGroupComponent,
  TableRowComponent,
  SwitchButtonWithDescriptionComponent,
  SubmitButtonGroupComponent,
  LanguageSwitchComponent,
  ProfileMenuSwitchComponent,
  CheckboxListComponent,
  AuthValidationComponent,
  NavigationListComponent,
  ChatModalComponent,
  UserMessageChatInputModalComponent,
  SearchButtonGroupComponent,
  SearchFormComponent,
  UserMessageThreadComponent,
  MessageContainerComponent,
  MessageComponent,
  AgreementCheckboxComponent,
  SkeletonLoaderComponent,
  AuthRecommendationModalComponent,
  PhoneInputComponent,
];

const DIRECTIVES: any[] = [];

const PIPES: any[] = [];

@NgModule({
  exports: [...DIRECTIVES, ...PIPES, ...COMPONENTS, ...MODULES_EXPORT],
  declarations: [...DIRECTIVES, ...PIPES, ...COMPONENTS],
  providers: [...SERVICES, ...PIPES],
  imports: [...MODULES],
})
export class ComponentModule {}
